(function () {
  var SELECTOR = '.product__media--video video';

  function play(video) {
    video.muted = true;
    video.setAttribute('playsinline', '');
    var promise = video.play();
    if (promise) promise.catch(function () {});
  }

  function init(root) {
    var videos = (root || document).querySelectorAll(SELECTOR);
    if (!videos.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(play);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play(entry.target);
          } else if (!entry.target.paused) {
            entry.target.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
